/* Footer bg : compact pill → full width as the footer enters the viewport */
export function footerCompact() {
  const g = document.querySelector('.footer__sup__bg');
  if (!g) return;
  const MAXX = 4.4, MAXY = 20, MAXR = 34;
  function update() {
    const vh = window.innerHeight;
    const r = g.closest('.footer__sup').getBoundingClientRect();
    if (r.bottom < -80 || r.top > vh + 80) return;
    const c = Math.max(0, Math.min(1, (vh - r.top) / (vh * 0.62)));
    const e = c * c * (3 - 2 * c);
    const inv = 1 - e;
    g.style.inset = (inv * MAXY).toFixed(1) + 'px ' + (inv * MAXX).toFixed(2) + 'vw';
    g.style.borderRadius = (inv * MAXR).toFixed(1) + 'px';
  }
  let ticking = false;
  function onScrollG() { if (!ticking) { ticking = true; requestAnimationFrame(() => { update(); ticking = false; }); } }
  update();
  window.addEventListener('scroll', onScrollG, { passive: true });
  window.addEventListener('resize', onScrollG, { passive: true });
}
